export default "__VITE_ASSET__DLIqJt05__"